import React from "react";
import { Card, Badge, Stack } from "react-bootstrap";
import { FaMapMarkerAlt } from "react-icons/fa";
import { SiGooglemaps } from "react-icons/si";

const StoreCard = () => {
  return (
    <Card
      className="shadow-sm border-0 mx-auto my-4 text-center"
      style={{ maxWidth: "420px", borderRadius: "12px" }}
    >
      <Card.Body className="p-4">
        {/* Header */}
        <div className="d-flex justify-content-center mb-3">
          <Badge
            bg="dark"
            className="px-4 py-2 fs-6 rounded-3 d-flex align-items-center gap-2"
          >
            Enayetpur
            <FaMapMarkerAlt />
          </Badge>
        </div>

        {/* Address */}
        <Card.Text className="text-muted small mb-3">
          Enayetpur, Gopalpur, Sirajganj
        </Card.Text>

        {/* Manager */}
        <Stack direction="horizontal" gap={2} className="justify-content-center mb-2">
          <span className="fw-semibold">Manager:</span>
          <a href="tel:01736433759" className="text-decoration-none">
            +88 01736-433759
          </a>
        </Stack>

        {/* Business Hours */}
        <Card.Text className="small mb-3">
          <span className="fw-semibold">Business Hours:</span>
          <br />
          Thu - Tue 10:30AM - 09:00PM
          <br />
          Wednesday Closed
        </Card.Text>

        {/* Google Maps Icon */}
        <a
          href="https://maps.google.com/?q=Narsingdi+Station+Road"
          target="_blank"
          rel="noopener noreferrer"
          className="text-success fs-2 d-inline-flex mt-2"
        >
          <SiGooglemaps />
        </a>
      </Card.Body>
    </Card>
  );
};

export default StoreCard;
